import {useGetUserPreferencesQuery} from 'services/userPreferences';
import {
  ActiveShortcutCommands,
  DefaultShortcuts,
  type ShortcutCommandMap,
} from '../types';
import {createActiveShortcutCommandMap} from '../functions';

export const useShortcuts = (): ShortcutCommandMap => {
  const {data} = useGetUserPreferencesQuery('shortcut');

  return createActiveShortcutCommandMap(
    ActiveShortcutCommands,
    DefaultShortcuts,
    data,
  );
};
